export default () => ({
  user: null,
  me: null
});
